import React from 'react';
import './Rings.css';

function Rings() {
  return (
    <div className="rings__background">
      <div className="rings__sizing">
        <div className="loader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
      </div>
    </div>
  )
}

export default Rings